import { render, staticRenderFns } from "./LayoutMessageCenter.vue?vue&type=template&id=157c79db"
import script from "./LayoutMessageCenter.vue?vue&type=script&lang=js"
export * from "./LayoutMessageCenter.vue?vue&type=script&lang=js"
import style0 from "./LayoutMessageCenter.vue?vue&type=style&index=0&id=157c79db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports